import { PureComponent } from "react";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import { MAIN_ID } from "constants/element-ids";
import BaseTemplate from "/components/templates/base-template";

import ArticleTemplateContentComponent from "./article-template-content/article-template-content-component";

import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component"; //new for monday 2.0
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component"; // //new for monday 2.0

export default class ArticleTemplate extends PureComponent {
  render() {
    let { headerUrl, exitPopup, loginTheme, menuTheme, stickyMode, pageConfig } = this.props;

    const {
      topbar,
      headerStrip,
      parts,
      footerSignup,
      nameSignature,
      socialButtons,
      topBanner,
      footer = {},
      exitPopupConfig
    } = pageConfig;

    const preventMenu = topbar && topbar.preventMenu;
    const preventFooter = footer && footer.preventFooter;

    return (
      <BaseTemplate {...this.props} {...pageConfig}>
        <BaseHeaderComponent
          url={headerUrl}
          loginTheme={loginTheme}
          menuTheme={menuTheme}
          showMenu={!preventMenu}
          headerBackgroundColor={"white"}
          stickyMode={stickyMode}
          allowSocialButtons={socialButtons && socialButtons.show}
          socialButtonsColor={socialButtons && socialButtons.color}
          socialButtonBlogStyle={socialButtons && socialButtons.blogStyle}
          topBanner={topBanner}
        />

        <main id={MAIN_ID}>
          <ArticleTemplateContentComponent
            headerStrip={headerStrip}
            parts={parts}
            footerSignup={footerSignup}
            footerDisclaimer={footer.disclaimer}
          />
        </main>

        {!preventFooter && (
          <LongFooterComponent nameSignature={nameSignature} showTrustpilotReviews={pageConfig.showTrustpilotReviews} />
        )}
        <CoreAddonsComponent exitPopup={exitPopup} exitPopupConfig={exitPopupConfig} />
      </BaseTemplate>
    );
  }
}

ArticleTemplate.defaultProps = {
  headerUrl: "https://monday.com/",
  title: "monday.com",
  description: "",
  exitPopup: true,
  menuTheme: "",
  loginTheme: ""
};
